import { Stack } from '@mui/material'

type Props = {
  children: React.ReactNode
}

export default function ModuleCourseList({ children }: Props) {
  return <Stack spacing={1}>{children}</Stack>
}
